skrilla.directive('sportSeasons',function() {
    return {
        templateUrl: 'directives/sportSeasons/sportSeasons.html',
        scope: {
            seasons: "=",
            sport: "=",
            navigate: "="
        },
        controller: function($scope){
        }
    };
});
